import { Dictionary } from '@/types/field'
import { createSelector } from 'reselect'

// Select entities from state
const getAuthState = (state: Dictionary) => state.auth

// = ====================================
//  MEMOIZED SELECTORS
// -------------------------------------

export const getAuthInfo = createSelector(getAuthState, (data: Dictionary) => {
    return {
        auth: data.auth,
        isAuth: data.isAuth,
        isLogin: data.isLogin,
        token:data.token ?? '',
        loading: data.loading
    }
})
